module.exports = __webpack_public_path__ + "img/icas.95f3e2c6.png";